import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { addStatistics } from '../require';
import showDiv from '@ivy/fts/showDiv';
import GiftListPopup from '../../comps/giftListPopup.vue';
let SpellGroup = class SpellGroup extends Vue {
    async created() { }
    async showCurrentGifts() {
        // const loginInfo = (await env.getIsLogin()) || {}
        // if (!loginInfo.token) {
        //   // 用户尚未注册
        //   await this.$store.showBindPhone()
        //   return this.$router.go(0)
        // }
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            this.$emit('ios10Shadow', true);
            return await env.login();
        }
        await showDiv(GiftListPopup, {
            visible: true,
            curLevel: this.curLevel,
            giftList: this.giftList,
        });
        // 埋点 点击商详页赠品
        addStatistics({
            event: 'Click_GoodDetails_Present_H5',
            p1: this.point,
            p2: this.goodsStatus,
        });
    }
};
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "giftList", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "point", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "goodsStatus", void 0);
SpellGroup = tslib_1.__decorate([
    Component({
        components: { GiftListPopup },
    })
], SpellGroup);
export default SpellGroup;
